export const WHOLESALE_STORE_ID = "wholesale";
export const WHOLESALE_STORE_NAME = "Veleprodaja";

export type WholesaleStatus = "draft" | "submitted" | "confirmed" | "packed" | "shipped" | "completed" | "cancelled";

export const WHOLESALE_STATUS_LABELS: Record<WholesaleStatus, string> = {
  draft: "Nacrt",
  submitted: "Zaprimljeno",
  confirmed: "Potvrđena",
  packed: "Spakovana",
  shipped: "Poslana",
  completed: "Završena",
  cancelled: "Otkazana",
};

/** Dozvoljeni prelazi. `packed → confirmed` je samo kroz izmjenu stavki. `submitted` je
 *  partnerska narudžba koja čeka operatera — iz nje se ide samo u potvrđeno ili otkazano. */
export const WHOLESALE_TRANSITIONS: Record<WholesaleStatus, WholesaleStatus[]> = {
  draft: ["submitted", "confirmed", "cancelled"],
  submitted: ["confirmed", "cancelled"],
  confirmed: ["packed", "shipped", "cancelled"],
  packed: ["shipped", "confirmed", "cancelled"],
  shipped: ["completed"],
  completed: [],
  cancelled: [],
};

/** Statusi koji ulaze u dug partnera. Zaprimljena narudžba (`submitted`) namjerno nije ovdje —
 *  nije dug dok je operater ne potvrdi. */
export const DEBT_STATUSES: WholesaleStatus[] = ["confirmed", "packed", "shipped", "completed"];

/** Statusi u kojima zaliha (wholesale_stock_jobs, pa time i pravi WooCommerce) još nije
 *  dirana — jedini put do prvog upisa je `confirm()`. Nacrt i zaprimljena narudžba dijele ovo
 *  svojstvo (Ruling R24): obje čekaju potvrdu, pa `cancel()` iz njih ne smije upisati
 *  kompenzacijski (pozitivan) posao — ništa nije skinuto da bi se vraćalo — a `setItems()` nad
 *  njima ne smije upisivati poslove razlike, nego samo zamijeniti stavke. Sljedeći status koji
 *  se doda s istim svojstvom ide ovdje, ne u nova poređenja sa `"draft"`. */
export const STOCK_UNTOUCHED_STATUSES: WholesaleStatus[] = ["draft", "submitted"];

/** Mapiranje u WooCommerce status za projekciju u mirror_orders. `submitted` je isto što i
 *  `draft` — zaprimljena narudžba se ne projektuje dok je operater ne potvrdi. */
export const WC_STATUS_FOR: Record<WholesaleStatus, string> = {
  draft: "pending",
  submitted: "pending",
  confirmed: "processing",
  packed: "completed",
  shipped: "completed",
  completed: "completed",
  cancelled: "cancelled",
};

export const STOCK_MAX_ATTEMPTS = 10;

export function round2(n: number): number {
  return Math.round((n + Number.EPSILON) * 100) / 100;
}
